/**
 @ngdoc service
 @name filterDataService

 @description
 Designed to make adding a filters to a smart table easier

 @usage
 Has the following public functions

 filterDataService.setDebug(_this.debug);
 filterDataService.createFilteredDataList( _this.responseData, _this.cellCache, _this.cellCache );
 filterDataService.filterAndFormatData( _this.responseData, _this.cellCache, _this.cellCache );

 @example


 */
var filterDataService = function($filter, logService, excelService) {
    //set up for debugging file
    var logObj = logService.init('filterDataService',false);

    this.setDebug = function(debug){
        logObj.debug = debug;
    };

    /**
     * Makes a "reference clone" of responseData.dataList .
     * The "reference clone" is held in responseData.filteredDataList .
     * This allows the filters to change responseData.filteredDataList whilst still maintaining the full responseData.dataList .
     * @param responseData - AJAX collected data - {{ dataList:[], headerLabels:{}, rowsPerPage: Number }}
     * @param cacheCellComparisionValue - Will cache the parsed cell values. Turn this off if you plan to alter the cell values
     * @param cacheFormattedValue - Whether to cache the formatted cell value. Do not use if altering display values - Boolean
     * @returns {{ id:{value:Number}, keyX:{value:Number}, keyY:{value:Number}, keyZ:{value:Number}  }}
     */
    this.createFilteredDataList = function( responseData, cacheCellComparisionValue, cacheFormattedValue){
        logObj.logTab('getFilteredDataList()', logResponseData(responseData) );
        checkData(responseData);
        //makes an array of references. e.g. modifying the original source data will modify, filtered model
        //responseData.filteredDataList = responseData.dataList.slice(0);
        this.filterAndFormatData(responseData, cacheCellComparisionValue, cacheFormattedValue);
        logObj.logTab('getFilteredDataList()', logResponseData(responseData), 'filteredDataList '+responseData.filteredDataList.length);
        return responseData.filteredDataList;
    };

    /**
     * Filters the data based upon the End User's selected filters.
     * Called any time a filter is changed. This re-iterates responseData.dataList checking that row matches the filters selected by the End User.
     * Future Efficiency Gain: Current traverses each Column, then each Row (A1>B1>A2>B2). This should eb altered to each Row, then each Column (A1>A2>B1>B2). Allowing for single column data collection.
     * @param responseData - AJAX collected data - {{ dataList:[], headerLabels:{}, rowsPerPage: Number }}
     * @param cacheCellComparisionValue - Will cache the parsed cell values. Turn this off if you plan to alter the cell values
     * @param cacheFormattedValue - Whether to cache the formatted cell value. Do not use if altering display values - Boolean
     * @returns {{ id:{value:Number}, keyX:{value:Number}, keyY:{value:Number}, keyZ:{value:Number}  }}
     */
    this.filterAndFormatData = function( responseData, cacheCellComparisionValue, cacheFormattedValue ){
        logObj.logTab('filterAndFormatData()', logResponseData(responseData));
        var filteredDataList = [];
        var row;
        for(var idx in responseData.dataList){
            row = responseData.dataList[idx];
            if( filterAndFormatRow(row, responseData.headerLabels, cacheCellComparisionValue, cacheFormattedValue) ) {
                filteredDataList.push(row);
            }
        }
        responseData.filteredDataList = filteredDataList;
        logObj.logTab('filterAndFormatData()', logResponseData(responseData), 'filteredDataList '+responseData.filteredDataList.length);
        return responseData.filteredDataList;
    };

    /**
     * Converts the JSON object to a CSV file
     * Based upon https://jsfiddle.net/1ecj1rtz/
     * @param responseData
     * @param useFilteredData
     * @param fileName
     * @param appendDownloadDateToFileName
     * @param showColumnHeaders
     * @param cacheFormattedValue - Whether to cache the formatted cell value. Do not use if altering display values - Boolean
     */
    this.download = function(responseData, useFilteredData, fileName, appendDownloadDateToFileName, showColumnHeaders, cacheFormattedValue){
        logObj.logTab('download()', [responseData, useFilteredData, fileName, appendDownloadDateToFileName, showColumnHeaders, cacheFormattedValue] );
        //decide which data to use
        var dataList = useFilteredData ? responseData.filteredDataList : responseData.dataList;
        var csv = excelService.newCSV( fileName );
        var row, cell, csvRow;
        //Will loop through adding header row
        if(showColumnHeaders) {
            csvRow = csv.newRow();
            //loop through each header key
            for (var headerKey in responseData.headerLabels) {

                csv.addCell(csvRow, responseData.headerLabels[headerKey].label);
            }
            csv.addRow(csvRow);
        }
        //loop through each row
        for(var idx in dataList){
            row = dataList[idx];
            csvRow = csv.newRow();
            for(var headerKey in responseData.headerLabels) {
                cell = row[headerKey];
                formatCell(responseData.headerLabels[headerKey], cell, cacheFormattedValue )
                csv.addCell(csvRow, cell.formattedValue);
            }
            csv.addRow(csvRow);
        }
        console.log( 'csv', csv );
        csv.download();
        logObj.logTab('download()', [responseData, useFilteredData, fileName, appendDownloadDateToFileName, showColumnHeaders, cacheFormattedValue],csv.csvData );
    };

    /**
     * Formats the Cell based upon the headerLabels formatting rules (if provided, else defaults to String)
     * @param header - The header information for that column. Used to decide upon the formatting rules. - {{  }}
     * @param cell - The cell object on the table
     * @param cacheFormattedValue - Whether to cache the formatted cell value. Do not use if altering display values - Boolean
     * @returns String formatted cell value
     */
    var formatCell = function(header, cell, cacheFormattedValue ){
        logObj.logTab('formatCell()', [header, cell, cacheFormattedValue], null, true );
        var formattedValue;
        if(cell) {
            //Collect the FORMAT type of the header
            var formatType = getFormatType(header.formatType)
            //Provides a class if required
            cell.cssClass = formatType.cssClass ? formatType.cssClass : '';
            //row[headerKey].formattedValue
            //If cache is on and we have a value use that one
            if( cacheFormattedValue && cell.formattedValue!=undefined ){
                formattedValue = cell.formattedValue;
                logObj.log('formatCell() cached format', formattedValue, true);
            } else {
                formattedValue = formatType.format(cell);
                logObj.log('formatCell() fresh format', formattedValue, true);
                cell.formattedValue = formattedValue;
            }
        } else {
            formattedValue = 'cell is undefined';
            console.warn(formattedValue);
        }
        logObj.logTab('formatCell()', [header, cell, cacheFormattedValue], formattedValue, true );
        return formattedValue;
    };

    /**
     * Collect the filter value's selection type. May wish to in future check size of drop-down
     * @param headerKey
     * @param header
     * @param responseData
     * @returns {*}
     */
    var getSelectionValues = function(headerKey,header,responseData){
        if( header.filter.type==='SELECTION' ) {
            if (!header.filter.selectionValues) {
                if (!header.filter.value) header.filter.value = 'ALL_VALUES';
                header.filter.selectionValues = {ALL_VALUES: CONFIG.FILTER.CONDITION_OPTION.ALL_VALUES};
                var cell;
                for (var idx in responseData.dataList) {
                    cell = responseData.dataList[idx][headerKey];
                    header.filter.selectionValues[cell.value] = {label: cell.value};
                }
            }
        }
        return header.filter.selectionValues;
    };

    /**
     * Do we need to provide End User filter options for this column?
     * @param header
     * @returns {boolean}
     */
    var hasFilter = function(header){
        header.filter.enabled = (header.filter.type!=='NONE');
        return header.filter.enabled;
    };

    /**
     * Debugging function - reduces the size of object passed to console
     * @param responseData
     * @returns {string|*}
     */
    var logResponseData = function( responseData ){
        if( !responseData.debugMsg ){
            responseData.debugMsg = 'responseData: {'+Object.keys(responseData)+'}';
        }
        return responseData.debugMsg;
    };

    /**
     * Pre prepare the data
     * @param responseData - AJAX collected data - {{ dataList:[], headerLabels:{}, rowsPerPage: Number }}
     * @returns {{ dataList:[], headerLabels:{}, rowsPerPage: Number }}
     */
    var checkData = function( responseData ){
        logObj.logTab('checkData()', logResponseData(responseData) );
        checkPrimaryKeys(responseData);
        checkAllHeaderLabelKeys(responseData);
        checkCheckboxAndActionsValues(responseData);
        logObj.logTab('checkData()', logResponseData(responseData), 'checked' );
        return responseData;
    };

    /**
     * Does the setup of the checbox and action object. Currently assumes these will be defined within row.id e.g. row.id.action
     * @param responseData
     */
    var checkCheckboxAndActionsValues = function( responseData ){
        logObj.logTab('checkCheckboxAndActionsValues()', logResponseData(responseData) );
        var row;
        for(var idx in responseData.dataList) {
            row = responseData.dataList[idx];
            var idValue = row.id.value.toString();
            if (row.id.checkbox) {
                row.id.checkbox.id = 'checkbox' + idValue;
            }
            if (row.id.action) {
                row.id.action.id = 'action' + idValue;
            }
        }
        logObj.logTab('checkCheckboxAndActionsValues()', logResponseData(responseData), 'checked' );
    };

    /**
     * Identifies if the row matches the End User's selected filters.
     * Future Efficiency Gain: Current traverses each Column, then each Row (A1>B1>A2>B2). This should eb altered to each Row, then each Column (A1>A2>B1>B2). Allowing for single column data collection.
     * @param row - The row the cell is within - {{ id:{value:Number}, keyX:{value:Number}, keyY:{value:Number}, keyZ:{value:Number}  }}
     * @param headerLabels
     * @param cacheCellComparisionValue - Will cache the parsed cell values. Turn this off if you plan to alter the cell values
     * @param cacheFormattedValue - Whether to cache the formatted cell value. Do not use if altering display values - Boolean
     * @return boolean row to be displayed
     */
    var filterAndFormatRow = function(row, headerLabels, cacheCellComparisionValue, cacheFormattedValue){
        logObj.logTab('filterAndFormatRow()', [row, headerLabels], null, true);
        var cell, header, rowMatch, formatType;
        for(var headerKey in headerLabels) {
            logObj.log('headerKey',headerKey,true);
            header = headerLabels[headerKey];
            //set if being filtered
            header.filter.beingFiltered = beingFiltered(header);
            cell = row[headerKey];
            if(cell) {
                //format the cell
                formatCell(header, cell, cacheFormattedValue);
                //Now check if we display that cell
                if( filterCell(header, cell, cacheCellComparisionValue) ) {
                    rowMatch = true;
                } else {
                    //don't filter for rest of columns
                    rowMatch = false;
                    break;
                }
            } else {
                console.warn('row is missing key \''+headerKey+'\'');
            }
        }
        logObj.logTab('filterAndFormatRow()', [row, headerLabels], rowMatch, true);
        return rowMatch;
    };

    /**
     * Identifies if the cell matches the End User's selected filters.
     * Future Efficiency Gain: Current traverses each Column, then each Row (A1>B1>A2>B2). This should eb altered to each Row, then each Column (A1>A2>B1>B2). Allowing for single column data collection.
     * @param header - The header information for that column. Used to decide upon the formatting rules. - {{  }}
     * @param cell - The cell object on the table
     * @param cacheCellComparisionValue - Will cache the parsed comparision cell values. Turn this off if you plan to alter the cell values
     * @returns {boolean}
     */
    var filterCell = function(header, cell, cacheCellComparisionValue){
        var HEADER_LABEL_TO_DEBUG = 'Week Ending Date';
        var comparisionCell = {
            header:                     header,
            cell:                       cell,
            cacheCellComparisionValue:  cacheCellComparisionValue,
            debugHeaderLabelled:        (header.label==HEADER_LABEL_TO_DEBUG),
            cellMatch:                  false,
            filterType:                 null,
            parsedFilterValue:          null,
            parsedCellValue:            null,
            filterConditionOption:      null
        };
        logObj.logTab('filterCell()',comparisionCell,null,!comparisionCell.debugHeaderLabelled);
        if( !header.filter.beingFiltered ){
            comparisionCell.cellMatch = true;
        } else {
            //Collect the FILTER type of the header, using the FORMAT type's default filter type
            comparisionCell.filterType = getFilterType( header.filter.type );
            //If required, parse the filter value into the correct data type
            comparisionCell.parsedFilterValue = comparisionCell.filterType.comparisionParse( header.filter.value, false );
            //If cache is on and we have a value use that one
            if( cacheCellComparisionValue && cell.comparisionValue!=undefined ){
                comparisionCell.parsedCellValue = cell.comparisionValue;
            } else {
                //If required, parse the cell value into the correct data type
                if (isEmpty(cell.value)) {
                    comparisionCell.parsedCellValue = '';
                } else {
                    comparisionCell.parsedCellValue = comparisionCell.filterType.comparisionParse(cell.value, true);
                }
                if (cacheCellComparisionValue) {
                    cell.comparisionValue = comparisionCell.parsedCellValue
                }
            }
            //Collect the Filter Condition Option
            comparisionCell.filterConditionOption = getFilterConditionOption( header.filter.condition );
            //Run the match function for that condition
            comparisionCell.cellMatch = comparisionCell.filterConditionOption.match( comparisionCell.parsedFilterValue, comparisionCell.parsedCellValue);
        }
        logObj.logTab('filterCell()',comparisionCell,comparisionCell.cellMatch,!comparisionCell.debugHeaderLabelled);
        return comparisionCell.cellMatch;
    };

    /**
     * List of properties code can assume is empty
     * @type {*[]}
     */
    var EMPTY_LIST = [undefined,'',null];

    /**
     * Identify empty properties
     * @param value
     * @returns {boolean}
     */
    var isEmpty = function(value){
        for(var idx in EMPTY_LIST){
            if(EMPTY_LIST[idx]===value){
                return true;
            }
        }
        return false;
    };

    /**
     * Are we filtering by this column
     * @param header
     * @returns {boolean}
     */
    var beingFiltered = function(header){
        return (hasFilter(header) && !(isEmpty(header.filter.value) || header.filter.value==='ALL_VALUES'));
    };

    /**
     * Collect a key value map of filter conditions for End User's selection based upon header's filter type
     * @param filterTypeKey
     * @returns {{}}
     */
    var getFilterConditions = function(filterTypeKey){
        var filterType = getFilterType(filterTypeKey);
        if( !filterType.filterConditionOptions ) {
            filterType.filterConditionOptions = {};
            var filterConditionKey;
            for (var idx in filterType.filterConditionKeyList) {
                filterConditionKey = filterType.filterConditionKeyList[idx];
                filterType.filterConditionOptions[filterConditionKey] = getFilterConditionOption( filterConditionKey );
            }
        }
        //log('getFilterConditions(\''+filterTypeKey+'\')',filterType.filterConditionOptions, true);
        return filterType.filterConditionOptions;
    };

    /**
     * Collect the FORMAT type of the header
     * @param formatTypeKey
     */
    var getFormatType = function(formatTypeKey){
        return getDefinedType(formatTypeKey, CONFIG.FORMAT_TYPE, 'getFormatType');
    };

    /**
     * Collect the FILTER type of the header, using the FORMAT type's default filter type
     * @param filterTypeKey
     */
    var getFilterType = function(filterTypeKey){
        return getDefinedType(filterTypeKey, CONFIG.FILTER.TYPE, 'getFilterType');
    };

    /**
     * Collect the Filter Condition Option
     * @param filterConditionKey
     */
    var getFilterConditionOption = function(filterConditionKey){
        return getDefinedType(filterConditionKey, CONFIG.FILTER.CONDITION_OPTION, 'getFilterConditionOption');
    };

    /**
     * Common method for getFormatType(), getFilterType(), getFilterConditionOption()
     * @param key
     * @param TYPE
     * @param functionName
     * @returns {*}
     */
    var getDefinedType = function(key,TYPE,functionName){
        var type;
        if(key){
            type = TYPE[key];
        }
        if(!type || key=='DEFAULT') {
            type = TYPE[TYPE.DEFAULT];
            if(key!='DEFAULT') {
                console.warn('Cannot find ' + functionName + '(\'' + key + '\'). Defaulting to \'' + TYPE.DEFAULT + '\'. Available options are ' + Object.keys(TYPE) + '.');
            }
        }
        //log( functionName + '(\'' + key + '\') formatType', type, true );
        return type;
    };

    /**
     * Common method for collecting cell vale
     * @param cell
     * @returns {string}
     */
    var getCellValue = function(cell){
        logObj.log('getCellValue()',cell,true);
        return (cell.value ? cell.value : '');
    };

    /**
     * CONFIGURATION
     */
    var CONFIG = {
        FILTER:{
            TYPE: {
                DEFAULT: 'TEXT',
                TEXT: {
                    inputType: 'text',
                    defaultFormatType: 'STRING',
                    filterConditionKeyList: ['CONTAINS', 'EQUAL', 'NOT_CONTAIN'],
                    comparisionParse: function(value, isCell){
                        var parsed = value.toString().toUpperCase();
                        return ( isCell ? parsed : parsed );
                    }
                },
                NUMERICAL: {
                    inputType: 'number',
                    defaultFormatType: 'NUMBER',
                    filterConditionKeyList: ['EQUAL', 'NOT_EQUAL', 'GREATER', 'LESS'],
                    comparisionParse: function(value, isCell){
                        return ( isCell ? value : Number(value) );
                    }
                },
                TIME_STAMP: {
                    inputType: 'date',
                    defaultFormatType: 'DATE_TIME',
                    filterConditionKeyList: ['EQUAL', 'NOT_EQUAL', 'BEFORE', 'AFTER'],
                    parseFilterValue: false,
                    parseCellValues: true,
                    comparisionParse: function(value, isCell){
                        var date = ( isCell ? new Date(value) : value );
                        return date.getTime();
                    }
                },
                SELECTION: {
                    inputType: 'select',
                    defaultFormatType: 'STRING',
                    filterConditionKeyList: ['EQUAL'],
                    comparisionParse: function(value, isCell){
                        return ( isCell ? value : value );
                    }
                },
                NONE:{}
            },
            CONDITION_OPTION: {
                CONTAINS: {
                    label: 'Contains',
                    match: function(filterValue, cellValue){
                        return cellValue.includes(filterValue);
                    }
                },
                EQUAL: {
                    label: 'Equal to',
                    match: function(filterValue, cellValue){
                        return filterValue===cellValue;
                    }
                },
                NOT_EQUAL: {
                    label: 'Is not equal to',
                    match: function(filterValue, cellValue){
                        return filterValue!==cellValue;
                    }
                },
                BEFORE: {
                    label: 'Equals anything before',
                    match: function(filterValue, cellValue){
                        return filterValue>cellValue;
                    }
                },
                AFTER: {
                    label: 'Equals anything after',
                    match: function(filterValue, cellValue){
                        return filterValue<cellValue;
                    }
                },
                GREATER: {
                    label: 'Greater than',
                    match: function(filterValue, cellValue){
                        return filterValue<cellValue;
                    }
                },
                LESS: {
                    label: 'Less than',
                    match: function(filterValue, cellValue){
                        return filterValue>cellValue;
                    }
                },
                NOT_CONTAIN: {
                    label: 'Does not contain',
                    match: function(filterValue, cellValue){
                        return !cellValue.includes(filterValue);
                    }
                },
                ALL_VALUES: {
                    label: 'All'
                }
            }
        },
        FORMAT_TYPE: {
            DEFAULT: 'STRING',
            STRING: {
                defaultFilterType: 'TEXT',
                format: function(cell){
                    return getCellValue(cell);
                }
            },
            ID: {
                defaultFilterType: 'TEXT',
                format: function(cell){
                    return getCellValue(cell).toString().padStart(8, '0');
                }
            },
            NUMBER: {
                defaultFilterType: 'NUMERICAL',
                format: function(cell){
                    return getCellValue(cell);
                }
            },
            MONETARY_WITH_RATE: {
                defaultFilterType: 'NUMERICAL',
                cssClass:'text-right',
                format: function(cell){
                    return getCellValue(cell);
                }
            },
            MONETARY: {
                defaultFilterType: 'NUMERICAL',
                cssClass:'text-right',
                format: function(cell){
                    return formatCurreny(getCellValue(cell),2);
                }
            },
            DATE: {
                defaultFilterType: 'TIME_STAMP',
                format: function(cell){
                    return $filter('date')(getCellValue(cell),"EEE dd/MM/yyyy");
                }
            },
            DATE_TIME: {
                defaultFilterType: 'TIME_STAMP',
                format: function(cell){
                    return $filter('date')(getCellValue(cell),"EEE dd/MM/yyyy HH:mm");
                }
            },
            TIME: {
                defaultFilterType: 'TIME_STAMP',
                format: function(cell){
                    return $filter('date')(getCellValue(cell),"HH:mm");
                }
            }
        }
    };

    var formatCurreny = function(value, fractionDigits){
        logObj.logTab('formatCurreny()',[value,fractionDigits],null,true);
        var mutiplier = Math.pow(10, fractionDigits);
        var formattedCurrency = parseFloat(Math.round(value * mutiplier) / mutiplier).toFixed(fractionDigits);
        logObj.logTab('formatCurreny()',[value,fractionDigits], formattedCurrency, true);
        return formattedCurrency;
    };

    /**
     * Checks the each header column has the necessary keys and values to work. Provides defaults to prevent code failures
     * @param responseData
     */
    var checkAllHeaderLabelKeys = function(responseData){
        logObj.logTab('checkAllHeaderLabelKeys()',responseData.headerLabels, null, false);
        var header;
        for(var headerKey in responseData.headerLabels){
            header = responseData.headerLabels[headerKey];
            checkHeaderLabelKeys(header);
            getSelectionValues(headerKey,header,responseData);
        }
        logObj.logTab('checkAllHeaderLabelKeys()',responseData.headerLabels, 'done', false);
    };

    /**
     * Checks the header column has the necessary keys and values to work. Provides defaults to prevent code failures
     * @param header
     * @returns {boolean}
     */
    var checkHeaderLabelKeys = function(header){
        logObj.logTab('checkHeaderLabelKeys()',header, null, false);
        if(!header.checked) {
            //Has a filter been defined?
            if (!header.filter) header.filter = {};
            //Has a filter type been defined?
            if (!header.filter.type) {
                header.filter.type = getFormatType(header.formatType).defaultFilterType;
            }
            var filterType = getFilterType(header.filter.type);
            if (!header.filter.condition) {
                header.filter.condition = filterType.filterConditionKeyList[0];
            }
            header.filter.conditions = getFilterConditions(header.filter.type);
            //header.filter.beingFiltered = beingFiltered(header);
            //filterValueIsDate
            header.filter.input = {
                type:       filterType.inputType,
                isDate:     (filterType.inputType==='date'),
                isSelect:   (filterType.inputType==='select')
            };
            //Has a formatType been defined?
            if (!header.formatType) {
                header.formatType = filterType.defaultFormatType;
            }
            header.checked = true;
        }
        logObj.logTab('checkHeaderLabelKeys()',header, header.checked, false);
        return header.checked;
    };

    /**
     * Check the data provided has the 3 main keys required for the filter table to work
     * @param responseData
     */
    var checkPrimaryKeys = function(responseData){
        logObj.logTab('checkPrimaryKeys()', logResponseData(responseData) );
        if(!responseData.dataList) {
            console.warn('Cannot find \'dataList\' key on the provided responseData. Generating mock \'dataList\'.');
            responseData.dataList = getMockData();
            mockHeaderLabels( responseData );
        }
        if(!responseData.headerLabels) {
            console.warn('Cannot find \'headerLabels\' key on the provided responseData. Mocking a \'headerLabels\'.');
            mockHeaderLabels( responseData );
        }
        if(!responseData.rowsPerPage) {
            console.warn('Cannot find \'rowsPerPage\' key on the provided responseData. Using default rowsPerPage.');
            responseData.rowsPerPage = DEFAULT.ROWS_PER_PAGE;
        }
        logObj.logTab('checkPrimaryKeys()', logResponseData(responseData), 'checked' );
    };

    var getMockData = function(){
        logObj.logTab('getMockData()',[] );
        if(!MOCK.DATA_LIST) {
            MOCK.DATA_LIST = [];
            for(var i=1,l=23;i<l;i++){
                MOCK.DATA_LIST.push({
                    id: {
                        value: i
                    },
                    columnA: {
                        value: "cell A"+i
                    },
                    columnB: {
                        value: "cell B"+i
                    },
                    columnC: {
                        value: i*7
                    }
                });
            }
        }
        logObj.logTab('getMockData()',[], MOCK.DATA_LIST);
        return MOCK.DATA_LIST;
    };

    var mockHeaderLabels = function(responseData){
        logObj.logTab('mockHeaderLabels()', logResponseData(responseData) );
        responseData.headerLabels = {};
        var firstRowsKeys = Object.keys( responseData.dataList[0] );
        for(var idx in firstRowsKeys){
            responseData.headerLabels[firstRowsKeys[idx]] = {formatType:'STRING',label:firstRowsKeys[idx]}
        }
        logObj.logTab('mockHeaderLabels()', logResponseData(responseData),'mocked' );
    };

    var MOCK = {
        DATA_LIST: null
    };
    var DEFAULT = {
        ROWS_PER_PAGE: 10,
        FILTER_TYPE: 'TEXT',
        FORMAT_TYPE: 'STRING'
    };
}

filterDataService.$inject = ['$filter', 'logService', 'excelService'];
angular.module('app').service('filterDataService', filterDataService);